import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as BaggageService from './../services/baggageService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParams } from '../utils/commonUtils';
import {
    setListBaggages as setListBaggagesAction,
    setBaggageDetail as setBaggageDetailAction
} from './../actions/baggageAction';
import history from './../helpers/history';
import moment from 'moment';
import { omit } from 'lodash';

function* getListBaggage() {
    yield takeLatest(Types.BAGGAGE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {})
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(BaggageService.getBaggage, params);
        yield put(setListBaggagesAction(result));
    }, errorHandleBaggage(Types.BAGGAGE_LIST_FAIL)))
}

function* getBaggageDetail() {
    yield takeLatest(Types.BAGGAGE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(BaggageService.getBaggageDetail, action.id);
        yield put(setBaggageDetailAction(result));
    }, errorHandleBaggage(Types.BAGGAGE_DETAIL_FAIL)))
}

function* updateBaggageDetail() {
    yield takeLatest(Types.BAGGAGE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(BaggageService.updateBaggageDetail, action.baggage.baggage);
        successHandleBaggage(action, action.baggage.baggage.class);
        yield put(setBaggageDetailAction(action.baggage.baggage));
        history.push(PATHS.BAGGAGE.LIST.path);
        history.go();
    }, errorHandleBaggage(Types.BAGGAGE_DETAIL_FAIL)))
}

function* createBaggageDetail() {
    yield takeLatest(Types.BAGGAGE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(BaggageService.createBaggageDetail, action.baggage);
        successHandleBaggage(action, action.baggage.class);
        yield put(setBaggageDetailAction(result));
        history.push(PATHS.BAGGAGE.LIST.path);
        history.go();
    }, errorHandleBaggage(Types.BAGGAGE_DETAIL_FAIL)))
}

function* deleteBaggageDetail() {
    yield takeLatest(Types.BAGGAGE_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(BaggageService.deleteBaggageDetail, action.baggage);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseListRequestParams(action.filters || {});
        const resultList = yield call(BaggageService.getBaggage, params.filters);
        yield put(setListBaggagesAction(resultList));
    }, errorHandleBaggage(Types.BAGGAGE_DETAIL_FAIL)));
}

function successHandleBaggage(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.baggage.title')} "${value}"`
    })
}

function errorHandleBaggage(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'baggage');
}

export function parseListRequestParamsCameo(params = {}) {
    const orderBy = params.OrderBy || params.orderBy || undefined;
    const orderByDesc = params.OrderByDesc !== undefined ? params.OrderByDesc : params.orderByDesc !== undefined ? params.orderByDesc : undefined;
    const startDate = params.startDate ? moment(params.startDate).toISOString() : undefined;
    const endDate = params.endDate ? moment(params.endDate).toISOString() : undefined;
    return {
        ...omit(params, ['OrderBy', 'OrderByDesc', 'totalCount', 'totalPage']),
        startDate, endDate, orderBy, orderByDesc,
        pageIndex: params.pageIndex && Number(params.pageIndex),
        pageSize: params.pageSize && Number(params.pageSize),
    }
}

export function* baggageSaga() {
    yield all([
        fork(getListBaggage),
        fork(getBaggageDetail),
        fork(updateBaggageDetail),
        fork(createBaggageDetail),
        fork(deleteBaggageDetail)
    ])
}
